import {
  makeStyles,
  Tag,
  TagDismissEvent,
  TagGroup,
  TagGroupProps,
  Tooltip,
  mergeClasses,
} from "@fluentui/react-components";
import { FlatVsaaTag } from "../../models/VsaaTag";
import { getTag } from "../../services/TagService";
import { useTranslation } from "react-i18next";

interface VsaaTagGroupProps {
  tags: FlatVsaaTag[];
  showPath?: boolean;
  onDismiss: (tag: FlatVsaaTag) => void;
}

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    maxWidth: "100%",
  },
  overflowXAuto: {
    overflowX: "auto",
  },
});

export const VsaaTagGroup = (props: VsaaTagGroupProps) => {
  const classes = useStyles();
  const { tags, onDismiss, showPath } = props;
  const { t } = useTranslation();

  const onDismissTag: TagGroupProps["onDismiss"] = (
    event: TagDismissEvent,
    { value }
  ) => {
    event.preventDefault();

    // Prevents the dismiss event from firing when clicking outside of the X icon.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((event.target as any).nodeName === "SPAN") {
      return;
    }

    const tag = getTag(value, tags);
    onDismiss(tag);
  };

  return (
    <TagGroup
      className={mergeClasses(classes.root, classes.overflowXAuto)}
      onDismiss={onDismissTag}
      aria-label={t("selectedTags")}
    >
      {tags.map((tag) => {
        return tag.path && tag.path.includes("/") ? (
          <Tooltip key={tag.id} content={tag.path} relationship="label">
            <Tag
              dismissible
              dismissIcon={{ "aria-label": t("delete") }}
              shape="rounded"
              value={tag.id}
            >
              {showPath ? tag.path : tag.title}
            </Tag>
          </Tooltip>
        ) : (
          <Tag
            key={tag.id}
            dismissible
            dismissIcon={{ "aria-label": t("delete") }}
            shape="rounded"
            value={tag.id}
          >
            {showPath ? tag.path : tag.title}
          </Tag>
        );
      })}
    </TagGroup>
  );
};
